<template>
  <div>
    <img id="img" :src="currentDocumento.documento + stgAccessKey" alt="" />
  </div>
</template>

<script>
import config from "@/config";

export default {
  name: "ModalPreviewImg",

  props: {
    currentDocumento: { type: Object },
  },

  data() {
    return {
      stgAccessKey: config.CD_STG_ACCESS_KEY,
    };
  },
};
</script>

<style scoped>
#img {
  width: 80%;
  height: 80%;
  display: block;
  margin-left: auto;
  margin-right: auto;
}
</style>
